import  { nanoid }  from 'nanoid';
import Cookies from 'universal-cookie';
import config from './config';
import constants from './constants';

const LWA_LOGIN_TIMES = 'lwa_login_times_spa';
const cookies = new Cookies();
const DAY_MILLISECONDS = 24 * 60 * 60 * 1000;
const LWA_UNIQ_ID_COOKIE = 'lwa_uniq_id_spa';
const ATHENA_AUTHORIZE_URL_COOKIE = 'athena-authorizeUrl';
const EKS_ROUTING_COOKIE = 'use-eks-routing';
const T_AND_C_SHOWN_SESSION_KEY = 'tAndCShown';
const UNIFIED_LOGIN_ROLLOUT_COOKIE = 'rollout_new_login_experience';
const MINUTE_MILLISECONDS = 60 * 1000;
const UNIFIED_LOGIN_ROLLOUT_TTL_DAYS = 180;
const COOKIE_OPTIONS = Object.freeze({ path: '/', httpOnly: false, secure: true });

export function setAndGetLwaUniqId() {
  if (!cookies.get(LWA_UNIQ_ID_COOKIE)) {
    const lwaUniqId = nanoid();
    // eslint-disable-next-line max-len
    cookies.set(LWA_UNIQ_ID_COOKIE, lwaUniqId, { ...crossDomainCookieOptions(), expires: new Date(Date.now() + (DAY_MILLISECONDS * 7)) });
  }
  const lwaUniqId = cookies.get(LWA_UNIQ_ID_COOKIE);

  //Previously this cookie was set on LWA domain, now we want to set it on .athenahealth.com, so read and update the domain
  cookies.set(LWA_UNIQ_ID_COOKIE, lwaUniqId, {
    ...crossDomainCookieOptions(),
    expires: new Date(Date.now() + (DAY_MILLISECONDS * 7)),
  });
  return cookies.get(LWA_UNIQ_ID_COOKIE);
}

export function getLwaLoginTimes() {
  return cookies.get(LWA_LOGIN_TIMES);
}

export function getXRoutingDeploymentValue() {
  return cookies.get(EKS_ROUTING_COOKIE) === true ? 'eks' : '';
}

export function setLwaLoginCookie(lwaLoginTimes) {
  return cookies.set(LWA_LOGIN_TIMES, lwaLoginTimes, COOKIE_OPTIONS);
}

export function removeLoginCookies() {
  cookies.remove(constants.ATHENA_OAUTH_STATE_COOKIE);
}

//Below cookies are read by OHSW, that is why they must be set on .athenahealth.com
const crossDomainCookieOptions = () => {
  return { ...COOKIE_OPTIONS, domain: '.athenahealth.com', expires: new Date(Date.now() + MINUTE_MILLISECONDS * 10) };
};

export function recordAuthorizeUrl(url) {
  cookies.set(ATHENA_AUTHORIZE_URL_COOKIE, url, crossDomainCookieOptions());
}

export function removeTAndCShownCookie() {
  cookies.remove(T_AND_C_SHOWN_SESSION_KEY, { domain: '.athenahealth.com', path: '/' });
}

// Clearing on false makes a rollback take effect on the next login rather than at expiry.
// Explicit expires: crossDomainCookieOptions() defaults to 10 minutes.
export function setUnifiedLoginRolloutCookie(decision) {
  if (!config.unifiedPatientLoginEnabled) return;
  if (decision !== true) {
    clearUnifiedLoginRolloutCookie();
    return;
  }
  cookies.set(UNIFIED_LOGIN_ROLLOUT_COOKIE, true, {
    ...crossDomainCookieOptions(),
    expires: new Date(Date.now() + (DAY_MILLISECONDS * UNIFIED_LOGIN_ROLLOUT_TTL_DAYS)),
  });
}

export function getUnifiedLoginRolloutDecision() {
  if (!config.unifiedPatientLoginEnabled) return false;
  // universal-cookie parses the stored value back to a boolean.
  return cookies.get(UNIFIED_LOGIN_ROLLOUT_COOKIE) === true;
}

function clearUnifiedLoginRolloutCookie() {
  cookies.remove(UNIFIED_LOGIN_ROLLOUT_COOKIE, { domain: '.athenahealth.com', path: '/' });
}
